import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;

    h1 {
        margin: 0;
        padding: 0;
        font-family: Montserrat;
        align-self: flex-start;
        font-size: 14px;
        font-weight: 600;
        text-align: left;
        color: #000000;
    }

    .buttons {
        width: 100%;
        display: flex;
        flex-direction: column;

        button {
            cursor: pointer;
            font-family: Montserrat;
            font-size: 12px;
            font-weight: 700;
            outline: none;
            border-radius: 100px;
            width: 100%;
            height: 32px;
            transition: 0.2s;
        }

        .senha {
            border: none;
            background-color: #c32027;
            color: #fff;
            margin-top: 24px;
            margin-bottom: 8px;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
        }

        .sair {
            border: 1.5px solid #c32027;
            color: #c32027;
            background-color: #fff;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
        }
    }
`